import React from 'react';
import SignupForm from './SignupForm';
import styles from '../RegisterForm/SignupFormCont.module.css';

const SignupFormCont = () => (
  <div className={styles['signup-container']}>
    <header className={styles.header}>
      <h3 className={styles['email-header']}>Register</h3>
      <hr />
    </header>
    <section>
      <SignupForm />
    </section>
  </div>
);

export default SignupFormCont;
